import localStorage from "@/services/localStorage.service";

function request(config) {
  config.headers["Authorization"] = localStorage.getItem("token") || "";
  return config;
}

function responseError(error) {
  let status = error.response.status;
  if (status === 401) logout();

  // Laravel Request Errors
  if (error.response.data.errors) {
    const keys = Object.keys(error.response.data.errors);
    const firstKey = keys[0];
    error.response.data.error = error.response.data.errors[firstKey][0];
  }

  return Promise.reject(error);
}

function logout() {
  localStorage.clear();
  if (!window.location.pathname.includes("auth")) {
    window.location.reload();
  }
}

export { request, responseError };



// WEBPACK FOOTER //
// ./src/services/axios/Api.interceptor.js